import { isBrSites } from './leads';

export function hasQacActionSource(actions) {
  if (!Array.isArray(actions)) {
    return false;
  }

  return actions.some(action => action?.source === 'QAC');
}

export function isQacLeadBlocked(actions) {
  return isBrSites() && hasQacActionSource(actions);
}
